export const RICH_TEXT_TOOL_BAR = 'Tools';

export const SYSTEM_FONT_OPTIONS = [
	{
		label: 'System UI',
		value:
			'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
	},
	{ label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
	{ label: 'Helvetica', value: 'Helvetica, Arial, sans-serif' },
	{ label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
	{ label: 'Tahoma', value: 'Tahoma, Geneva, sans-serif' },
	{ label: 'Trebuchet MS', value: '"Trebuchet MS", Helvetica, sans-serif' },
	{ label: 'Segoe UI', value: '"Segoe UI", Tahoma, Geneva, sans-serif' },
	{ label: 'Gill Sans', value: '"Gill Sans", "Gill Sans MT", Calibri, sans-serif' },
	{
		label: 'Century Gothic',
		value: '"Century Gothic", CenturyGothic, AppleGothic, sans-serif',
	},
	{ label: 'Lucida Sans', value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif' },
	{ label: 'Arial Black', value: '"Arial Black", Gadget, sans-serif' },
	{ label: 'Impact', value: 'Impact, Charcoal, sans-serif' },
	{ label: 'Times New Roman', value: '"Times New Roman", Times, serif' },
	{ label: 'Georgia', value: 'Georgia, serif' },
	{ label: 'Palatino', value: '"Palatino Linotype", "Book Antiqua", Palatino, serif' },
	{ label: 'Garamond', value: 'Garamond, serif' },
	{ label: 'Bookman', value: '"Bookman Old Style", serif' },
	{ label: 'Courier New', value: '"Courier New", Courier, monospace' },
	{ label: 'Lucida Console', value: '"Lucida Console", Monaco, monospace' },
	{ label: 'Monospace', value: 'Menlo, Monaco, Consolas, "Liberation Mono", monospace' },
	{ label: 'Sans Serif', value: 'sans-serif' },
	{ label: 'Serif', value: 'serif' },
] as const;
